"use client";
import Select, { Option } from "@/components/primitives/select";
import { useRouter } from "next/navigation";

interface StateSelectorProps {
  label: string;
  options: Option[];
  defaultValue: string;
}

export default function StateSelector(props: StateSelectorProps) {
  const router = useRouter();

  return (
    <>
      <Select
        label={props.label}
        options={props.options}
        defaultValue={props.defaultValue}
        height={16}
        onValueChange={(value) => {
          router.push(`/legal-state/${value}`);
        }}
      />
    </>
  );
}
